import { UsersBus } from '../../../cp/shared/models/UsersBus.model';
import { EntityState, EntityStore, Store, StoreConfig } from '@datorama/akita';
import { Injectable } from "@angular/core";

/**
* @deprecated This type is deprecated and will be removed in future versions.
*/
export type AkitaAuthState = {
    user: UsersBus | null;
}

/**
* @deprecated This const is deprecated and will be removed in future versions.
*/
export const initialState: AkitaAuthState = {
    user: null
};

/**
* @deprecated This class is deprecated and will be removed in future versions.
*/
@Injectable()
@StoreConfig({ name: 'auth' })
export class AkitaAuthStore extends Store<AkitaAuthState> {
    constructor() {
        super(initialState);
    }

    login(user: UsersBus) {
        this.update({ user });
    }

    logout() {
        this.update(initialState);
    }
}